// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jYWjhDgRDtjW3q8CYX_2 {\r\n  font-family: \"Lato\", sans-serif;\r\n  height: 100%;\r\n}\r\n._RxtY7HTs9uTBr2mm3wV {\r\n  margin-top: 66px;\r\n  min-height: 90vh;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".app {\r\n  font-family: \"Lato\", sans-serif;\r\n  height: 100%;\r\n}\r\n.content {\r\n  margin-top: 66px;\r\n  min-height: 90vh;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "jYWjhDgRDtjW3q8CYX_2",
	"content": "_RxtY7HTs9uTBr2mm3wV"
};
export default ___CSS_LOADER_EXPORT___;
